export default "__VITE_ASSET__99789e25__"